<template>
  <div class="paper-upload">
    <head-top :navActive="navActive"></head-top>
    <div class="upload-head">
      <div class="head-top-bg-box">
        <div class="logo"><img src="../../static/img/ts-img/logo.png" alt=""></div>
        <p class="txt">{{top_title_big}}</p>
        <p class="txt">{{top_title_small}}</p>
      </div>
    </div>
    <!-- 内容 start -->
    <div class="paper-upload-box">
      <div class="paper-upload-main">
        <div class="paper-upload-main-left">
          <div class="download-btn" @click="$router.push('/reportDownload')">
<!--            <img-->
<!--              src="../../static/img/ts-img/download-btn.png"-->
<!--              width="270"/>-->
            <div class="download-cursor">
              <span>点击下载检测结果</span>
              <i>
                <img src="../../static/img/fffdown.png" alt="">
              </i>
            </div>
          </div>
          <div class="paper-range-title">论文检测文献库范围</div>
          <div class="paper-range-list">
            <p v-for="item in wenxianList" :key="item.id">{{item.title}}</p>
          </div>
          <div class="up-content-bg">
            <img :src="Banner" width="290" />
          </div>
          <div class="paper-range-title">系统主要适用范围</div>
          <div class="paper-range-list">
            <p v-for="item in fanweiList" :key="item.id">{{item.title}}</p>
          </div>
        </div>
        <div class="paper-upload-main-right">
          <div class="paper-upload-main-right-top">
            <p v-for="(item,index) in test" :key="index">{{index+1}}. {{item.title}}</p>
          </div>
          <div class="report-download-line"></div>
          <!-- 上传文件部分 start -->
          <div class="upload-list-table">
            <div class="upload-list-nav">
              <a>单篇上传</a>
            </div>
            <div class="upload-list-table-content">
              <div class="input-box">
                <span>论文标题：</span>
                <div class="input-div">
                  <el-input
                    type="paperTitle"
                    placeholder="填写真实标题，不超过50字"
                    v-model="paperTitle"
                    maxlength="50"
                    show-word-limit
                  ></el-input>
                </div>
              </div>
              <div class="input-box">
                <span>论文作者：</span>
                <div class="author-input-div">
                  <el-input
                    type="paperOther"
                    placeholder="填写真实作者，不超过15字"
                    v-model="paperOther"
                    maxlength="15"
                    show-word-limit
                    onafterpaste="this.value=this.value.replace(/，/g,',')" onkeyup="this.value=this.value.replace(/，/g,',')"
                  ></el-input>
                </div>
                <span class="author-input-span">[多作者用英文","逗号分隔]</span>
                <div class="attr-sort">
                  <span>属性分类：</span>
                  <select class="select-option" v-model="paperType">
                    <option v-for="item in list" :key="item.id" :value="item.id">{{item.name}}</option>
                  </select>
                </div>
              </div>
              <div class="upload-box">
                <p class="upload-box-title">选择文件：</p>
                <div class="upload-box-inner">
                  <p><span v-show="upload">请上传word、txt、pdf文档，且小于30M</span>{{fileName}}</p>
                  <div>
                    <el-upload
                      class="upload-demo"
                      action=""
                      :limit="1"
                      accept=".doc, .docx, .txt, .pdf"
                      :beforeUpload="beforeAvatarUpload"
                      :show-file-list="false"
                      :http-request="OSSinit"
                      :on-success="handleSuccess"
                      ref="upload"
                    >
                      <el-button size="small" type="primary" v-show="successUpLoad">上传待测论文</el-button>
                      <el-button
                        size="small"
                        type="primary"
                        v-show="!successUpLoad"
                        @click="clearUploadedFile"
                      >重新上传</el-button>
                    </el-upload>
                  </div>
                </div>
                <el-progress
                  v-show="fileFlag == true"
                  :text-inside="true"
                  :color="customColors"
                  :percentage="percent"
                  style="margin-top: 20px"
                ></el-progress>
              </div>
              <div class="pay-methods">
                <p class="pay-methods-title">支付方式：</p>
                <div class="pay-methods-content">
                  <div
                    class="pay-methods-content-item"
                    @click="isWxPay=true"
                    :class="{active:isWxPay==true}"
                  >
                    <i>
                      <img src="../../static/img/ts-img/wechat-icon.png" width="104" />
                    </i>
                  </div>
                  <div
                    class="pay-methods-content-item"
                    :class="{active:isWxPay==false}"
                    @click="isWxPay=false"
                  >
                    <i>
                      <img src="../../static/img/ts-img/alpay-icon.png" width="91" />
                    </i>
                  </div>
                </div>
              </div>
              <div class="input-box">
                <span>手机号码：</span>
                <div class="input-div">
<!--                  <el-input-->
<!--                    type="otherTel"-->
<!--                    placeholder="请输入正确的手机号码"-->
<!--                    v-model="otherTel"-->
<!--                    maxlength="50"-->
<!--                    show-word-limit-->
<!--                    onkeyup="value=value.replace(/[^\d]/g,'') " ng-pattern="/[^a-zA-Z]/"-->
<!--                    style="border:1px solid red;"-->
<!--                  ></el-input>-->
                  <input type="text" v-model="otherTel" maxlength="11" style="width:230px;height: 30px;margin-top: 5px;border:1px solid #3b6bda;padding-left: 10px">
                  <p class="tel-tips">提示：请输入正确手机号，手机号是下载报告凭证</p>
                </div>
              </div>
              <button class="submit-btn" @click="sumbitTestButton">提交检查</button>
            </div>
          </div>
          <!-- 上传文件部分 end -->
          <div class="report-download-line" style="height: 20px"></div>
          <!-- 常见问题 start -->
          <div class="qa">
            <p class="qa-title">
              <i></i>
              <span>常见问题</span>
            </p>
<!--            <ul class="qa-list">-->
<!--              <li class="qa-list-item" v-for="(item,index) in matterList" :key="index">-->
<!--                <p class="active">-->
<!--                  <span>{{index+1}}.{{item.name}}</span>-->
<!--                  <i @click="item.is_open=0" style="transform:rotate(0deg)">-->
<!--                    <img v-show="item.is_open==1" src="../../static/img/ts-img/zhankai-icon.png" width="26" />-->
<!--                  </i>-->
<!--                   <i @click="item.is_open=1"  v-show="item.is_open==0">-->
<!--                    <img v-show="item.is_open==0" src="../../static/img/ts-img/zhankai-icon.png" width="26" />-->
<!--                  </i>-->
<!--                </p>-->
<!--                <ul class="qa-list-item-list" v-show="item.is_open==0">-->
<!--                  <li v-for="(ins,index) in item.information_list" :key="index">-->
<!--                    <span>{{ins.title}}</span>-->
<!--                  </li>-->
<!--                </ul>-->
<!--              </li>-->
<!--            </ul>-->
            <div class="qa-list">
              <el-collapse accordion>
                <el-collapse-item v-for="(item,index) in matterList" :key="index">
                  <template slot="title">{{index+1}}.{{item.name}}</template>
                  <div
                    class="zmr-paper-retract-li"
                    v-for="(ins,index) in item.information_list" :key="index">{{ins.title}}</div>
                </el-collapse-item>
              </el-collapse>
            </div>
          </div>
          <!-- 常见问题 end -->
        </div>
      </div>
    </div>
    <!-- 内容 end -->
    <foot-bottom></foot-bottom>
  </div>
</template>

<script>
import headTop from "../components/header/head-top";
import footBottom from "../components/footer/foot-bottom";
import tool from "./../assets/js/tool.js";

import OSS from 'ali-oss';
export default {
  name: "paper-upload",
  data() {
    return {
      file: null,
      navActive: 2,
      paperTitle: "", //论文标题
      paperOther: "", //论文作者
      fileUrl: "",
      paperType: "", //论文类型
      isWxPay: true, //是否是微信支付
      percent: 0, //上传文件百分比
      fileFlag: false, //是否显示进度条
      successUpLoad: true,
      customColors: "#3b6bda",
      otherTel: "", //手机号
      wenxianList: [], //文献列表
      fanweiList: [], //范围列表
      matterList: [], //问题列表
      Banner:'',//banner图
      lock:false, //锁
      test:[],
      list: [],
      orderId: null,
      top_title_big:'',//头部大标题
      top_title_small:'',//头部小标题
      fileName:'',//上传文件名
      upload:true,//上传之前提示内容
    };
  },
  components: {
    headTop,
    footBottom
  },
  mounted() {
    this.init();
    this.getHeadtextInfo()
  },
  methods: {
    init() {
      this.getTestXianList();
      this.getfanweiList();
      this.getMatter();
      this.getSting();
      this.getBanner();
      this.getAttrList()
    },
    // 获取属性列表
    getAttrList(){
tool.postData('get_attribute_list',null,res=>{
  this.list=res.data.data.list
})
    },
    // 获取文献列表
    getTestXianList() {
      var queryParams = {
        information_category_id: 16,
        goods_id: this.$route.query.id
      };
      tool.postData("get_information_list", queryParams, res => {
        this.wenxianList = res.data.data.list;
      });
    },
    getSting(){
      var queryParams={
        information_category_id:23,
        goods_id: this.$route.query.id,
      };
      tool.postData('get_information_list',queryParams,res=>{
        this.test=res.data.data.list
      })
    },

    getBanner(){
      var queryParams={
        type:1,
        position:2,
        goods_id: this.$route.query.id,
      };
      tool.postData('get_banner',queryParams,res=>{
        this.Banner=res.data.data.banner_image
      })
    },
    // 获取范围列表
    getfanweiList() {
      var queryParams = {
        information_category_id: 17,
        goods_id: this.$route.query.id,
      };
      tool.postData("get_information_list", queryParams, res => {
        this.fanweiList = res.data.data.list;
      });
    },
    // 获取常见问题
    getMatter() {
      tool.postData("get_common_problem", null, res => {
        this.matterList = res.data.data.category_list;
      });
    },
    /* 上传之前 */
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 30;
      if (!isLt2M) {
        this.$message({
          message: "上传文件大小不能超过 30MB!",
          type: "warning"
        });
      }
      var testmsg=file.name.substring(file.name.lastIndexOf('.')+1)
      const extension = testmsg === 'doc'
      const extension2 = testmsg === 'docx'
      const extension3 = testmsg === 'txt'
      const extension4 = testmsg === 'pdf'
      if(!extension && !extension2  && !extension3 && !extension4) {
        this.$alert(
        <div class="errAlert">
          <img src="./../../static/img/err.jpg"/>
          <div class="info">
          <h4>上传失败</h4>
          <p>请查看上传文件是否存在问题</p>
          </div>
          </div>,
        "",
          {
            dangerouslyUseHTMLString: true
          }
      );
      }
      //this.OSSinit(file)
    },
    /* 上传成功 */
    handleSuccess(res, file) {

     if(res){
       this.percent=100;
       this.fileFlag = true;
     }
      this.successUpLoad = false;

     /* if (res) {
        var param = new FormData();
        param.append("file_data", file.raw);
        tool.postData("upload_file", param, res => {
          this.fileUrl = res.data.data.url;
          this.$alert(
            <div class="errAlert">
              <img src="./../../static/img/res.png" />
              <div class="info">
                <h4 style="color:#3b6bda">上传成功</h4>
                <p>上传文件成功</p>
              </div>
            </div>,
            "",
            {
              dangerouslyUseHTMLString: true
            }
          );
            this.fileFlag = false
          },
        ); // 项目中用后台返回的真实地址
      } else {
        this.$alert(
          <div class="errAlert">
            <img src="./../../static/img/err.jpg" />
            <div class="info">
              <h4>上传失败</h4>
              <p>请查看上传文件是否存在问题</p>
            </div>
          </div>,
          "",
          {
            dangerouslyUseHTMLString: true

          }
        );
      }*/
    },
    /* 上传过程 */
   // uploadProcess(event, file, fileList) {
   //    this.fileFlag = true;
   //    this.percent = Math.floor(event.percent);
   //    this.fileName = file.name;
   //    this.upload=false
   //    console.log(this.percent)
   //  },
    /* 重新上传 */
    clearUploadedFile() {
      this.$refs.upload.clearFiles();
    },
    // 提交检查按钮
    sumbitTestButton() {
      if(this.lock==true){
        return
      }
      if (!this.paperTitle) {
        this.$message({
          message: "标题头部不能为空",
          type: "warning"
        });
        return this.lock=true;
      }
      if (!this.paperOther) {
        this.$message({
          message: "标题作者不能为空",
          type: "warning"
        });
        return this.lock=true;
      }
      if (!this.paperType) {
        this.$message({
          message: "标题分类不能为空",
          type: "warning"
        });
        return this.lock=true;
      }
      if (!this.otherTel) {
        this.$message({
          message: "手机号不能为空",
          type: "warning"
        });
        return this.lock=true;
      }
      let queryParams = {
        title: this.paperTitle,
        author: this.paperOther,
        paper_url: this.fileUrl,
        phone: this.otherTel,
        goods_id: this.$route.query.id,
        attribute_id: this.paperType
      };
      tool.postData("submit_order", queryParams, res => {
        this.orderId = res.data.data.order_sn;
          this.$router.push({
            path: "/payPage/",
            query:{
              id:this.orderId,
              type:this.isWxPay
            }
          });
      });
    },
    OSSinit(file) {
      console.log(file)
      this.file=file.file
      this.fileName = file.file.name
      // fileName = new String(fileName.getBytes("gbk"),"iso8859-1");
      this.upload=false;
      var client = new OSS({
        region: "oss-cn-beijing",
        accessKeyId: "LTAI4FoiwSU57x6WxLBToiZr",
        accessKeySecret: "hJ5GlRzHu0sQ1NHMyLzUrSgnrIIumB",
        bucket: "cnkijc"
      });
      var flieInfo = this.file.name.split(".");
      var storeAs = "upload/" + timestamp() +"."+ flieInfo[flieInfo.length-1];
      console.log(storeAs);
      var that = this;
      client
        .multipartUpload(storeAs, this.file, {
          progress: async function(p) {
            //p进度条的值
            console.log(p);
            that.fileFlag = true;
            that.percent = Math.floor(p * 100);
          }
        })
        .then(function(result) {
          if(result.res.status==200){
            //console.log('http://cnkijc.oss-cn-beijing.aliyuncs.com/'+result.name)
           that.fileUrl = 'http://cnkijc.oss-cn-beijing.aliyuncs.com/'+result.name
            // alert('上传成功')
            that.$alert(
            <div class="errAlert">
              <img src="./../../static/img/res.png" />
              <div class="info">
              <h4 style="color:#3b6bda">上传成功</h4>
              <p>上传文件成功</p>
              </div>
              </div>,
            "",
              {
                dangerouslyUseHTMLString: true
              }
          );
          }
        })
        .catch(function(err) {
          console.log(err);
        });
      function timestamp() {
        var time = new Date();
        var y = time.getFullYear();
        var m = time.getMonth() + 1;
        var d = time.getDate();
        var h = time.getHours();
        var mm = time.getMinutes();
        var s = time.getSeconds();
        var ms = time.getMilliseconds();
        console.log(y);
        return (
          "" + y + add0(m) + add0(d) + add0(h) + add0(mm) + add0(s) + add0(ms)
        );
      }

      function add0(m) {
        return m < 10 ? "0" + m : m;
      }
    },
    /* 支付按钮 */
    /*payMethodFun() {
      this.$router.push({
        path: "/payPage/"
      });
    }
    getBasicInfo () {
      let data = {

      };
      tool.postData('get_setting',data,(res) => {
        this.logoImg = res.data.data.logo_top;
      });
    },*/
    getHeadtextInfo () {
      let data = {
        goods_id:this.$route.query.id
      };
      tool.postData('get_goods_detail',data,(res) => {
        this.top_title_big = res.data.data.top_title_big;
        this.top_title_small = res.data.data.top_title_small;
      });
    },
  },
  watch:{
       lock:function(o,v){
         console.log(o)
         if(o==true){
           var self=this
           setTimeout(()=>{
             self.lock=false
           },3000)
         }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../assets/style/common";
.paper-upload{
  position: relative;
}
.upload-head{
  width: 100%;
  height: 90px;
  background: url("../../static/img/top.png") no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  .head-top-bg-box{
    width: $box-width;
    height: 90px;
    margin: 0 auto;
    @include flex;
    .logo{
      width: 120px;
      height:45px;
      padding: 10px;
      img{
        height: 100%;
      }
    }
    .txt{
      @include font(20px,#fff);
      font-weight: bold;
    }
  }
}
.errAlert {
  display: flex;
  justify-content: flex-start;
  padding: 0 25px;
  img {
    width: 100px;
    height: 100px;
  }
  .info {
    padding-left: 30px;
    h4 {
      color: #ef6676;
      font-size: 30px;
      margin-top: 15px;
    }
    p {
      font-size: 16px;
      color: #999999;
      margin-top: 20px;
    }
  }
}
.paper-upload {
  width: 100%;
  height: 100%;
  background-color: #eff4ff;
}
.paper-upload-box {
  width: 100%;
  background: url("../../static/img/nav.png") no-repeat top center;
  padding-top: 80px;
  box-sizing: border-box;
  margin-bottom: 60px;
  .paper-upload-main {
    width: $box-width;
    margin: 0 auto;
    @include flex($align: flex-start);
    .paper-upload-main-left {
      width: 291px;
      background-color: #fff;
      padding: 0 10px;
      box-sizing: border-box;
      .download-btn {
        border-bottom: 1px solid #c4d2f4;
        /*cursor: pointer;*/
        width: 270px;
        height:90px;
        padding-top: 15px;
        box-sizing: border-box;
        .download-cursor{
          cursor: pointer;
          background-color: #eb8c52;
          width:250px;
          height:60px;
          margin:0 auto;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 10px;
          span{
            color:#fff;
            font-size: 18px;
            margin-right: 10px;
          }
          i{
            display: block;
            width:20px;
            height:20px;
            overflow: hidden;
            img{
              width: 100%;
              height: 100%;
            }
          }
        }
        .download-cursor:hover span{
          /*box-shadow: 0 2px 10px 2px #bfbdbc;*/
          margin-right:30px;
        }
      }
      .paper-range-title {
        text-align: center;
        @include font(24px, #3b6bda);
        line-height: 65px;
        font-weight: bold;
        border-bottom: 1px solid #c4d2f4;
      }
      .paper-range-list {
        padding: 20px 25px 15px;
        box-sizing: border-box;
        line-height: 38px;
        p {
          line-height: 23px;
          margin-bottom: 20px;
          position: relative;
          &:before {
            content: "";
            width: 5px;
            height: 5px;
            border-radius: 50%;
            background-color: #3b6bda;
            display: inline-block;
            vertical-align: middle;
            margin-right: 10px;
            position: absolute;
            top: 9px;
            left: -10px;
          }
        }
      }
      .up-content-bg {
        position: relative;
        left: -10px;
      }
    }
    .paper-upload-main-right {
      width: 893px;
      background-color: #fff;
      .paper-upload-main-right-top {
        padding: 30px 40px;
        box-sizing: border-box;
        p {
          @include font(16px, #f14040);
          line-height: 35px;
        }
      }
      .upload-list-table {
        .upload-list-nav {
          width: 100%;
          height: 80px;
          border-bottom: 1px solid #c4d2f4;
          display: flex;
          align-items: center;
          a {
            width: 142px;
            line-height: 37px;
            margin-left: 30px;
            text-align: center;
            @include font(16px, #fff);
            background-color: #3b6bda;
            border-radius: 5px;
          }
        }
        .upload-list-table-content {
          padding: 10px 28px 20px;
          box-sizing: border-box;
          .input-box {
            margin-top: 20px;
            @include flex($content: flex-start);
            span {
              @include font(16px, #666);
            }
            .input-div {
              border-radius: 5px;
              width: 362px;
              height: 40px;
              .tel-tips {
                @include font(14px, #3b6bda);
                line-height: 30px;
              }
            }
            .author-input-div {
              width: 220px;
            }
            .author-input-span {
              @include font(14px, #999);
              margin-left: 10px;
            }
            .attr-sort {
              display: flex;
              align-items: center;
              margin-left: 23px;
              .attr-sort-select {
                width: 169px;
                height: 40px;
                border: 1px solid #c4d2f4;
                border-radius: 5px;
                position: relative;
                padding: 0 10px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                p {
                  @include font(14px, #999);
                  line-height: 40px;
                  width: 128px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                i {
                  border: 5px solid transparent;
                  border-top-color: #3b6bda;
                  &.active {
                    transform: rotate(180deg);
                  }
                }
                .attr-sort-option {
                  width: 100%;
                  top: 42px;
                  left: 0;
                  position: absolute;
                  border: 1px solid #c4d2f4;
                  border-radius: 5px;
                  background-color: #fff;
                  p {
                    width: 100%;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    padding: 0 10px;
                    box-sizing: border-box;
                    cursor: pointer;
                    &:hover {
                      background-color: #3b6bda;
                      color: #fff;
                    }
                  }
                }
              }
            }
          }
          .upload-box {
            margin-top: 10px;
            .upload-box-title {
              @include font(16px, #666);
              line-height: 40px;
            }
            .upload-box-inner {
              display: flex;
              align-items: center;
              p {
                width: 363px;
                line-height: 39px;
                border: 1px solid #c4d2f4;
                border-radius: 5px;
                padding-left: 15px;
                box-sizing: border-box;
                @include font(14px, #999);
                margin-right: 10px;
                background-color:#ccc;
                color: #fff;
              }
            }
          }
          .pay-methods {
            margin-top: 10px;
            .pay-methods-title {
              @include font(16px, #666);
              line-height: 40px;
            }
            .pay-methods-content {
              display: flex;
              width: 322px;
              justify-content: space-between;
              .pay-methods-content-item {
                width: 150px;
                height: 60px;
                @include flex($content: center);
                border-radius: 4px;
                border: 2px solid #c4d2f4;

                &.active {
                  border-width: 2px;
                  border-color: #41b035;
                }
              }
            }
          }
          .submit-btn {
            width: 148px;
            line-height: 42px;
            background-color: #3b6bda;
            text-align: center;
            @include font(18px, #fff);
            border-radius: 5px;
            margin-top: 50px;
            font-weight: bold;
            cursor: pointer;
          }
          .submit-btn:hover{
            background-color:#409EFF;
          }
        }
      }
      .qa {
        width: 100%;
        background-color: #fff;
        padding: 0 30px 50px;
        box-sizing: border-box;
        .qa-title {
          display: flex;
          align-items: center;
          i {
            width: 10px;
            height: 10px;
            background-color: #3b6bda;
            margin-right: 10px;
          }
          span {
            @include font(25px, #333);
            font-weight: bold;
            line-height: 82px;
          }
        }
        .qa-list {
          /*li {
            p {
              border: 1px solid #c4d2f4;
              border-bottom: none;
              @include flex;
              height: 48px;
              padding: 0 20px;
              box-sizing: border-box;
              &.active {
                border-bottom: 1px solid #c4d2f4;
                i {
                  transform: rotate(180deg);
                }
              }

              span {
                @include font(18px, #333);
              }
            }
            &:last-child {
              p {
                border-bottom: 1px solid #c4d2f4;
              }
            }
            .qa-list-item-list {
              box-sizing: border-box;
              padding: 10px 0 10px 22px;
            }
          }*/
          .zmr-paper-retract-li:before{
            content: "\25CF";
            color: #3b6bda;
            margin-right: 5px;
          }
          .zmr-paper-retract-li{
            box-sizing: border-box;
            padding: 10px 0 10px 22px;
            font-size: 16px;
            color: #666;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
.select-option {
  border: 1px solid #c4d2f4;
  height: 40px;
  border-radius: 5px;
  cursor: pointer;
}
.report-download-line {
  width: 100%;
  height: 10px;
  background-color: #eff4ff;
}
</style>
<style>
.el-input__inner {
  border: 1px solid #c4d2f4;
  padding: 0 10px;
}
.el-button--primary {
  width: 140px;
  height: 42px;
  background-color: #3b6bda;
  border-radius: 7px;
  font-size: 14px;
}
.el-progress {
  width: 362px;
}
.el-progress-bar__outer {
  height: 20px !important;
}
.el-progress-bar__innerText {
  font-size: 14px;
  text-align: center;
  width: 100%;
}
.el-collapse-item__header {
  line-height:60px;
  font-size:18px;
  color: #333;
  border: 1px solid #c4d2f4;
  padding: 0 24px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.el-collapse-item__header.is-active {
  border-bottom-color: #c4d2f4;
}
.el-collapse-item__arrow{
  border:1px solid #3b6bda;
  color: #3b6bda;
  transform: rotate(90deg);
  border-radius: 50%;
  font-size: 24px;
}
.el-collapse-item__arrow.is-active {
  -webkit-transform: rotate(270deg);
  transform: rotate(270deg);
}
.el-collapse-item__content{
  padding-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/paper-upload.vue